import moment from "moment";

// Helper function to convert date to selected timezone
export const convertDateToTimezone = (dateString, timezone) => {
    if (!dateString || !timezone) return dateString;

    try {
        const date = new Date(dateString);
        // Convert to timezone-specific string
        return new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(date);
    } catch (error) {
        console.error('Error converting date:', error);
        return dateString;
    }
};

export const formatDateForInput = (dateString, timezone) => {
    if (!dateString) return "";

    if (timezone) {
        return convertDateToTimezone(dateString, timezone);
    }

    return moment(dateString).format('YYYY-MM-DD');
};


export const convertDateToMonthStrShort = dateString => {
    // Create a Date object
    const date = new Date(dateString);
    // console.log(dateString); // "Jan"
    // Method 1A: Using toLocaleString with options
    const monthShort = date.toLocaleString('default', { month: 'short' });
    console.log(monthShort); // "Jan"
    return monthShort;
}; 